import { Avatar } from '../components/ChatParts';

// Reuse the real contact-photo endpoint, lazy loading and expired-URL recovery.
export default function ContactAvatar({ contact }) {
  return <span className={`mobile-avatar avatar-${Number(contact.id) % 5}`} aria-hidden="true">
    <Avatar key={contact.id} contactId={contact.id} name={contact.name} initialUrl={contact.avatar_url} size={48} />
  </span>;
}
